import React, { PropsWithChildren } from 'react'
import clsx from 'clsx'
import { Align as AlignStyles, Justify as JustifyStyles, Row as RowStyles } from '@airbus/elements/elements'
import { createUseStyles } from '../../lib/styling'
import useDeprecatedProps from '../../lib/hooks/useDeprecatedProps'
import { AlignItems, JustifyContent, Spacing } from '../helperTypes'
import { CommonProps } from '../helperTypes'

type Props = PropsWithChildren<{
  /**
   * Defines the `justify-content` style property.
   */
  justify?: JustifyContent
  /**
   * Defines the `align-items` style property.
   */
  alignItems?: AlignItems
}>

type DeprecatedProps = {
  spacing?: Spacing
}

export type RowProps = Props & DeprecatedProps & CommonProps

const useStyles = createUseStyles(RowStyles, 'row')
const useJustifyStyles = createUseStyles(JustifyStyles, 'justify')
const useAlignStyles = createUseStyles(AlignStyles, 'align')

const Row = (props: RowProps) => {
  const { alignItems, children, className, justify, spacing, ...rest } = props
  useDeprecatedProps('Row', { spacing: undefined }, props)

  const classes = useStyles()
  const alignClasses = useAlignStyles()
  const justifyClasses = useJustifyStyles()

  return (
    <div
      className={clsx(
        classes.root,
        className,
        justify && justifyClasses[`content-${justify}`],
        alignItems && alignClasses[`items-${alignItems}`],
      )}
      {...rest}
    >
      {children}
    </div>
  )
}

export default Row
